import React from 'react'
import AdminLevelListingComponent from '../../Components/adminLevelListingComponent'

const LevelListingPage = () => {
  return (
    <div className="main-wrapper">
      <div className="content-wrapper">
        <AdminLevelListingComponent/>
      </div>
    </div>
    
  )
}

export default LevelListingPage